import React, { useState } from 'react';
import {
    DataTable,
    Table,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    TableCell,
    TableContainer,
    TableToolbar,
    TableToolbarContent,
    TableToolbarSearch,
    Pagination,
    TableSelectRow,
    TableSelectAll
} from '@carbon/react';

const SelectableTable = ({ title, rows, headers, onSelectionChange, ...args }) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);

    return (
        <DataTable
            rows={rows}
            headers={headers}
            {...args}
            isSortable
            radio={false}
        >
            {({
                rows,
                headers,
                getHeaderProps,
                getRowProps,
                getSelectionProps,
                getTableProps,
                getToolbarProps,
                onInputChange,
                getTableContainerProps,
                selectedRows
            }) => (
                <TableContainer title={title} {...getTableContainerProps()}>
                    <TableToolbar {...getToolbarProps()} aria-label="toolbar">
                        <TableToolbarContent>
                            <TableToolbarSearch placeholder="Buscar" onChange={onInputChange} />
                        </TableToolbarContent>
                    </TableToolbar>

                    <Table {...getTableProps()} aria-label="tabla seleccionable">
                        <TableHead>
                            <TableRow>
                                <TableSelectAll {...getSelectionProps()} />
                                {headers.map(header => {
                                    const { key, ...rest } = getHeaderProps({ header });
                                    return (
                                        <TableHeader key={key} {...rest}>
                                            {header.header}
                                        </TableHeader>
                                    );
                                })}

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.slice((page - 1) * pageSize, page * pageSize).map(row => {
                                const { key: rowKey, ...rowProps } = getRowProps({ row });
                                return (
                                    <TableRow key={rowKey} {...rowProps}>
                                        <TableSelectRow {...getSelectionProps({ row })} />
                                        {row.cells.map(cell => (
                                            <TableCell key={cell.id}>{cell.value}</TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody>

                    </Table>

                    <Pagination
                        totalItems={rows.length}
                        pageSizes={[5, 10, 15]}
                        itemsPerPageText="Elementos por página"
                        pageRangeText={(current, total) => `${current}–${total} página(s)`}
                        itemRangeText={(min, max) => `${min}–${max} Filas`}
                        pageNumberText="Número de página"
                        page={page}
                        pageSize={pageSize}
                        onChange={({ page, pageSize }) => {
                            setPage(page);
                            setPageSize(pageSize);
                        }}
                        forwardText="Página siguiente"
                        backwardText="Página anterior"
                    />

                    {onSelectionChange && onSelectionChange(selectedRows)}

                </TableContainer>
            )}
        </DataTable>
    );
};

export default SelectableTable;
